import {createAction} from '@reduxjs/toolkit'

import {APIStatusType, MobileEasyPayPinStatusType} from '@web/core/constants'

/** 휴대폰 일반 결제 번호 입력 */
export const inputMobileNumbers = createAction<string>('mobile/inputMobileNumbers')

/** 휴대폰 간편 결제 번호 입력 */
export const inputEasyMobileNumbers = createAction<string>('mobile/inputEasyMobileNumbers')

/** 휴대폰 간편 결제 비밀번호 입력 */
export const inputEasyMobilePinNo = createAction<string>('mobile/inputEasyMobilePinNo')

/** 휴대폰 간편결제 상태 변경 */
export const changeEasyMobilePinStatus = createAction<MobileEasyPayPinStatusType>('mobile/changeEasyMobilePinStatus')

/** 휴대폰 간편결제 변경할 결제 비밀번호  변경 */
export const changeEasyMobileNewPin = createAction<{newPinNo: string; confirmPinNo: string}>(
    'mobile/changeEasyMobileNewPin',
)

/** 휴대폰 간편결제 데이터 변경 대기 상태 */
export const changeMobileEasyPayApiStatus = createAction<APIStatusType>('mobile/changeMobileEasyPayApiStatus')
